module.exports = __webpack_public_path__ + "img/IMG_2708.218bb3b9.jpg";